import { callGetApiToServer } from "../callApi";

export async function getAllFilterPaidTransactions(
  authtoken,
  vendorId,
  startDate,
  endDate,
  skipNumber,
  limitNumber
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl =
      "v1/auth/filter-vendor-paid-transaction/" +
      vendorId +
      "/" +
      startDate +
      "/" +
      endDate +
      "/" +
      skipNumber +
      "/" +
      limitNumber;

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
